// import React from 'react';
// import './Home.css';
// import { ReactTyped } from 'react-typed';
// import {
//   FaFacebookF, FaLinkedinIn, FaInstagram,
//   FaGithub, FaJava, FaReact,
// } from 'react-icons/fa';
// import { SiSpringboot, SiMysql, SiMongodb, SiAngular } from 'react-icons/si';
// import About from './About';
// import Skills from './Skills';
// import Projects from './Projects';
// import Contact from './Contact';

// const Home = () => {
//   return (
//     <>
//       <div
//         className="home"
//         style={{
//           backgroundImage: `url(${process.env.PUBLIC_URL + '/code.jpg'})`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat',
//         }}
//       >
//         <div className="overlay">
//           <div className="home-left">
//             <p className="intro-text">Welcome In My Feed</p>
//             <h1>
//               Hello, I'm a <span className="typed-text">
//                 <ReactTyped
//                   strings={['Viraj Mhatre','Programmer', 'Full Stack Developer', 'Java Developer']}
//                   typeSpeed={80}
//                   backSpeed={50}
//                   loop
//                 />
//               </span>
//             </h1>
//             <p className="bio">
//               Welcome to my portfolio! I’m a full-stack developer with a passion for creating
//               innovative and efficient web solutions. With expertise in both front-end and
//               back-end technologies, I craft seamless, user-centric applications that solve
//               real-world problems. Whether building responsive websites, developing scalable
//               applications, or optimizing system performance, my goal is to deliver exceptional
//               results.
//             </p>

//             <div className="icons-container">
//               <div>
//                 <p className="icon-title">Available on</p>
//                 <div className="icons">
                  
//                   <a href="https://www.linkedin.com/in/viraj-mhatre-163b8725a/" target="_blank" rel="noreferrer">
//                     <FaLinkedinIn />
//                   </a>
                  
//                   <a href="https://github.com/Viru-mhatre/VirajMhatre" target="_blank" rel="noreferrer">
//                     <FaGithub />
//                   </a>
//                 </div>
//               </div>

//               <div>
//                 <p className="icon-title">Currently Working on</p>
//                 <div className="icons">
//                   <FaJava /><SiSpringboot /><SiMysql /><SiAngular /><FaReact /><SiMongodb />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="home-right">
//             <img src="/Virajphoto.jpg" alt="Viraj Mhatre" className="profile-img" />
//           </div>
//         </div>
//       </div>

//       {/* ✅ About section */}
//       <About />
//       <Skills />
//       <Projects/>
//       <Contact/>
//     </>
//   );
// };

// export default Home;


// Pages/Home.js
import React from 'react';
import './Home.css';
import { ReactTyped } from 'react-typed';
import {
  FaGithub, FaLinkedinIn, FaJava, FaReact,
} from 'react-icons/fa';
import { SiSpringboot, SiMysql, SiMongodb, SiAngular } from 'react-icons/si';
import About from './About';
import Skills from './Skills';
import Projects from './Projects';
import Contact from './Contact';

const Home = () => {
  return (
    <>
      <div
        className="home"
        id="home"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + '/code.jpg'})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="overlay">
          <div className="home-left">
            <p className="intro-text">Welcome In My Feed</p>
            <h1>
              Hello, I'm a <span className="typed-text">
                <ReactTyped
                  strings={['Viraj Mhatre', 'Programmer', 'Full Stack Developer', 'Java Developer']}
                  typeSpeed={80}
                  backSpeed={50}
                  loop
                />
              </span>
            </h1>
            <p className="bio">
             Welcome to my portfolio! I’m a full-stack developer with a passion for creating
          innovative and efficient web solutions. With expertise in both front-end and
               back-end technologies, I craft seamless, user-centric applications that solve
               real-world problems. Whether building responsive websites, developing scalable
               applications, or optimizing system performance, my goal is to deliver exceptional
               results.
            </p>

            <div className="icons-container">
              <div>
                <p className="icon-title">Available on</p>
                <div className="icons">
                  <a href="https://www.linkedin.com/in/viraj-mhatre-163b8725a/" target="_blank" rel="noreferrer">
                    <FaLinkedinIn />
                  </a>
                  <a href="https://github.com/Viru-mhatre/VirajMhatre" target="_blank" rel="noreferrer">
                    <FaGithub />
                  </a>
                </div>
              </div>

              <div>
                <p className="icon-title">Currently Working on</p>
                <div className="icons">
                  <FaJava /><SiSpringboot /><SiMysql /><SiAngular /><FaReact /><SiMongodb />
                </div>
              </div>
            </div>
          </div>

          <div className="home-right">
            <img src="/Virajphoto.jpg" alt="Viraj Mhatre" className="profile-img" />
          </div>
        </div>
      </div>

      <About />
      <Skills />
      <Projects />
      <Contact />
    </>
  );
};

export default Home;

